import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { rem, getResetByTag } from '../../../../../styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("padding:", rem(16, 16, 16, 0), ";>:nth-of-type(2){margin-left:", rem(16), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var resetStyles = getResetByTag('div');
var StyledModalFooterInner = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1m6eh9u0"
} : {
  target: "e1m6eh9u0",
  label: "StyledModalFooterInner"
})(resetStyles, defaultStyles);
export default StyledModalFooterInner;